<div class="user-menu">
  @if(currentUser) {
  <svg
    alt="User profile"
    class="user-avatar focus-circular"
    tabindex="0"
    [data-jdenticon-value]="currentUser.username"
    (click)="toggleDropdown()"
    aria-label="User menu"
    [attr.aria-expanded]="isDropdownOpen"
    aria-haspopup="true"
    appClickOutside
    (clickOutside)="closeDropdown()"
  ></svg>
  }
  <div class="user-dropdown" role="menu" [class.show]="isDropdownOpen">
    <div class="dropdown-header">
      @if(currentUser) {
      <div class="user-info-name">
        {{ currentUser.first_name }} {{ currentUser.surname }}
      </div>
      <div class="user-info-email">{{ currentUser.email }}</div>
      } @else {
      <div class="user-info-name">Loading...</div>
      }
    </div>
    <ul class="dropdown-menu">
      @if(currentUser && isAdmin) {
      <li calss="dropdown-menu">
        <div
          type="button"
          class="dropdown-link"
          role="menuitem"
          (click)="switchProfile()"
        >
          <span class="material-icons">swap_horiz</span>
          <span>Switch Profile</span>
        </div>
      </li>
      } @if(currentUser && isImpersonating) {
      <li calss="dropdown-menu">
        <div
          type="button"
          class="dropdown-link"
          role="menuitem"
          (click)="stopImpersonating()"
        >
          <span class="material-icons">swap_horiz</span>
          <span>Exit Impersonation</span>
        </div>
      </li>
      }
      <app-theme-switcher></app-theme-switcher>
      <li class="dropdown-divider" role="separator"></li>
      <li class="dropdown-item">
        <button
          type="button"
          class="dropdown-link danger"
          role="menuitem"
          (click)="logout()"
        >
          <span class="material-icons">logout</span>
          <span>Sign Out</span>
        </button>
      </li>
    </ul>
  </div>
</div>
